/** NEON DRIFT art direction: neon on near-black, three accent families. */
export const PALETTE = {
  void: '#04040a',
  deck: '#0b0b16',
  deckEdge: '#121222',
  playerBody: '#141420',
  playerAccent: '#22e6ff', // cyan — the player's signature color
  playerTrail: '#18c8ff',
  cell: '#b8ff2e', // energy cells — acid green
  supercell: '#fff45e',
  hazardFirewall: '#ff2e6d', // low barrier — magenta/red
  hazardPylon: '#7a5cff', // tall pillar — violet
  hazardDrone: '#ffa028', // moving drone — amber
  hazardGate: '#ff4db8', // gate arch — pink
  laneLine: '#1d4a66',
  skylineA: '#0e1c3a',
  skylineB: '#251445',
  fogColor: '#140b30',
} as const;
